<template>
  <el-container class="energy-price" direction="vertical">
    <common-panel :panel-data="panelData"/>
  </el-container>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "DemandSetting",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        tableTitle: '响应单价预估列表',
        hasTree: false,
        hasMenu: true,
        energyItem: [{'id': '1', 'name': '电'}],
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSiteDemand,
        filterForm: [
          {label: '站点名称：', prop: 'siteName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '设置单价', icon: 'zy-icon-setting-gear', type: 'updateRows', handleIndex: 1}
        ],
        methods: {
          edit: this.$api.systemManage.updateSiteDemand,
          update_prop: 'id'
        },
        tableCheck: true,
        tableProps: [
          {prop: "siteName", label: "站点名称"},
          {prop: "minPrice", label: "响应单价预计低值"},
          {prop: "maxPrice", label: "响应单价预计高值"}
        ],
        drawerTitle: '单价信息',
        dialogs: {
          add_edit: {
            title: '单价信息',
            width: '700px',
            items: [
              {type: 'input', prop: 'minPrice', label: '响应单价预计低值：', placeholder: '请输入响应单价预计低值', style: 'width: 315px;'},
              {type: 'input', prop: 'maxPrice', label: '响应单价预计高值：', placeholder: '请输入响应单价预计高值', style: 'width: 315px;'}
            ],
            rules: {
              minPrice: [
                {required: true, message: '请输入响应单价预计低值', trigger: 'blur'}
              ],
              maxPrice: [
                {required: true, message: '请输入响应单价预计高值', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .energy-price{
    width: 100%;
    height: 100%;
  }
  .el-menu{
    background: white;
  }
  .el-menu .el-menu-item{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/DemandSetting.vue